///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { BomConfigDTO } from '../../../../../generated/shared-types.model';

export class GtthSetProjectBomCommand extends GtthAbstractCommand {
    private bomConfig: BomConfigDTO;

    getCommandName(): string {
        return 'GtthSetProjectBomCommand';
    }

    create(bomConfig: BomConfigDTO): this {
        this.bomConfig = bomConfig;
        return this;
    }

    doCommandActivity(activityDTO: ActivityDTO): void {
        if (!activityDTO.successful && activityDTO?.error?.message) {
            this.historyService.notificationService.showError(activityDTO.error.message);
        }

        if (this.commandResolve) {
            this.commandResolve(activityDTO.successful);
        }
    }

    protected doCommand(): void {
        if (!this.bomConfig) {
            this.commandResolve(true);
        }
        const setBomActivity = this.createActivityDTO(false);
        setBomActivity.bomConfig = this.bomConfig;
        this.sendActivity(setBomActivity);
    }
}
